import { render, staticRenderFns } from "./ModalChatRules.vue?vue&type=template&id=52dfeca5&scoped=true"
import script from "./ModalChatRules.vue?vue&type=script&lang=js"
export * from "./ModalChatRules.vue?vue&type=script&lang=js"
import style0 from "./ModalChatRules.vue?vue&type=style&index=0&id=52dfeca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfeca5",
  null
  
)

export default component.exports